<template>

  <div class="modal-mask" v-show="showUserWatchModal" transition="modal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <slot name="header">Пользователь</slot>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label>Имя</label>
            <input disabled type="text" class="form-control" v-model="user.name" required/>
          </div>
          <div class="form-group">
            <label>E-mail</label>
            <input disabled type="email" class="form-control" v-model="user.email"/>
          </div>
          <div class="form-group">
            <label>дата окончания действительности</label>
            <input disabled type="date" class="form-control" v-model="user.valid_till1"/>
          </div>
          <div class="form-group">
            <label>ПИНФЛ</label>
            <input disabled type="text" class="form-control" v-model="user.pinfl"/>
          </div>
          <div class="form-group">
            <label> имя пользователя</label>
            <input disabled type="text" class="form-control" v-model="user.first_name"/>
          </div>
          <div class="form-group">
            <label> фамилию пользователя</label>
            <input disabled type="text" class="form-control" v-model="user.surname"/>
          </div>
          <div class="form-group">
            <label> отчество пользователя</label>
            <input disabled type="text" class="form-control" v-model="user.patronymic"/>
          </div>
          <div class="form-group">
            <label> организацию пользователя</label>
            <input disabled type="text" class="form-control" v-model="user.org_name"/>
          </div>
          <div class="form-group">
            <label> должность пользователя</label>
            <input disabled type="text" class="form-control" v-model="user.level"/>
          </div>
          <div class="form-group">
            <label> телефон пользователя (pattern : +123(12)123-12-12)</label>
            <input disabled type="text" class="form-control" v-model="user.phone"/>
          </div>
        </div>

        <div class="modal-footer">
          <slot name="footer">
            <button class="modal-button btn btn-danger" @click="updateModal({modal:'watch',visible:false})">Закрыть
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showUserWatchModal: false,
    user: {}
  },
  data() {
    return {
    }
  },
  methods: {
    updateModal(state, event = 'update'){
      this.$emit(event,state);
    },
  }
}
</script>

<style scoped>

</style>